import { ComponentDocs } from "components/docs";
import { ComponentExample } from "components/examples";
import { ExternalProps } from "constants/external";

const FormNumeric = () => (
  <ComponentDocs
    name="<Form.Numeric/>"
    entry="Numeric"
    propsEntry="NumericProps"
    namespace="FormFields"
    externalProps={ExternalProps.MuiOutlinedInput}
  >
    <ComponentExample
      name="Numeric input"
      import={import("examples/Forms/FormNumeric/NumericInputExample")}
      rawImport={import("examples/Forms/FormNumeric/NumericInputExample?raw")}
    />
    <ComponentExample
      name="Min / max values"
      import={import("examples/Forms/FormNumeric/MinMaxValuesExample")}
      rawImport={import("examples/Forms/FormNumeric/MinMaxValuesExample?raw")}
    />
    <ComponentExample
      name="Decimal numbers"
      import={import("examples/Forms/FormNumeric/DecimalNumbersExample")}
      rawImport={import("examples/Forms/FormNumeric/DecimalNumbersExample?raw")}
    />
    <ComponentExample
      name="Currency"
      import={import("examples/Forms/FormNumeric/CurrencyExample")}
      rawImport={import("examples/Forms/FormNumeric/CurrencyExample?raw")}
    />
    <ComponentExample
      name="Debounced numeric"
      import={import("examples/Forms/FormNumeric/DebouncedNumericInputExample")}
      rawImport={import(
        "examples/Forms/FormNumeric/DebouncedNumericInputExample?raw"
      )}
    />
  </ComponentDocs>
);

export default FormNumeric;
